import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Table, message } from 'antd';
import React, { useEffect, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import qs from 'qs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { reverse } from 'named-urls';
import { getUser } from '../../../controller/api/userServices';
import { getAdminDetail } from '../../../controller/localStroageHandler';

const getRandomuserParams = (params) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const User = () => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

   let userDetail = getAdminDetail()
  useEffect(() => {
    setLoading(true);
    getUser({id: userDetail?.organization_id?._id}).then((res) => {
      setData(res?.data.data);
      // setTotal(res?.data?.total);
      setLoading(false);
    }).catch((err) => {
      console.log('err ===>', err);
    })
  }, []);
  const columns = [
    {
      title: 'FirstName',
      dataIndex: 'firstName',
      sorter: true,
    },
    {
      title: 'LastName',
      dataIndex: 'lastName',
      sorter: true,
      className: 'text-capitalize fw-medium',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      sorter: true,
      className: 'text-capitalize fw-medium',
    },
    {
      title: 'PhoneNo',
      dataIndex: 'phoneNo',
      sorter: true,
      className: 'text-capitalize fw-medium',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      sorter: true,
      className: 'text-capitalize fw-medium',
    },
    {
      title: 'Password',
      dataIndex: 'password',
      sorter: false,
      className: 'text-capitalize fw-medium',
    },
    {
      title: (
        <div className='w-100 d-flex justify-content-end'>
          <Button
            className='rounded-5 fw-bold d-flex justify-content-center align-items-center fw-semibold btn-border-color text-color-custom custom-hover-btn'
            onClick={() => navigate(routes.admin.dashboard.user.add)}
          >
            Add +
          </Button>
        </div>
      ),
      dataIndex: '',
      render: (record) => (
        <div className='d-flex gap-4 text-color-custom justify-content-end'>
          {/* <FontAwesomeIcon
            icon={faPenToSquare}
            style={{ cursor: 'pointer' }}
            onClick={() =>
              navigate(
                reverse(routes.admin?.dashboard?.questionnaire?.edit, {
                  id: record?.id,
                })
              )
            }
          />{' '} */}
          <FontAwesomeIcon
            style={{ cursor: 'pointer' }}
            icon={faTrashCan}
            onClick={() => {
             
            }}
          />
        </div>
      ),
    },
  ];
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
 
  return (
    <div className='w-100 h-100 p-4 bg-light'>
      <AdminSearchBarHeader search={search} setSearch={setSearch} />
      <Row align={'middle'} className='mt-4 mb-4'>
        <Col span={24} className='fs-6 fw-semibold'>
          Organization User
        </Col>
      </Row>
      <Table
        className='table-container'
        scroll={{
          y: 320,
          x: 600,
        }}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data}
        // pagination={{
        //   ...tableParams.pagination,
        //   showSizeChanger: true,
        //   total: total,
        //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
        // }}
        loading={loading}
        // onChange={handleTableChange}
      />
    </div>
  );
};

export default User;
